import React from 'react';

import {
  SelectBaseRTK,
  type SelectBaseRTKProps,
} from 'app/components/general/SelectBase/SelectBaseRTK';
import {ActionMeta} from 'app/components/general/SweetReactSelect';
import {convertLocationParamsToFetchParams, useTags} from 'app/tags/api';

import type {NewTagType, TagsDashboardFetchParamsType} from 'app/tags/types';
import type {TagSerializedType} from 'sweet-types';

type TagsSelectBaseProps = {
  [K in keyof SelectBaseRTKProps<
    TagSerializedType,
    TagsDashboardFetchParamsType
  >]?;
};

type Props = TagsSelectBaseProps & {
  placeholder: string;
  disabled?: boolean;
  refetchDataOnOpen?: boolean;
  params?: Record<string, string | number>;
  selected: Array<TagSerializedType | NewTagType>;
  onChange: (
    tags: Array<TagSerializedType | NewTagType>,
    meta: ActionMeta<TagSerializedType | NewTagType>
  ) => void;
};

export const TagsSelect = ({
  selected,
  refetchDataOnOpen,
  onChange,
  placeholder,
  disabled,
  params,
  ...other
}: Props) => (
  <SelectBaseRTK<TagSerializedType, TagsDashboardFetchParamsType>
    isRTKFetcher={true}
    params={params}
    placeholder={placeholder}
    disabled={disabled}
    isMulti={true}
    selected={selected}
    onChange={onChange}
    useDataHook={useTags}
    paramsConverter={convertLocationParamsToFetchParams}
    typeIcon="fas fa-tag"
    refetchDataOnOpen={refetchDataOnOpen}
    {...other}
  />
);
